export default "__VITE_ASSET__d759ccea__"